<template>
  <div class="list-item-inner">
    <div
      class="list-item-inner__data-row"
      :title="source.message"
    >
      {{ source.resume || "—" }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'list-item',
  props: {
    source: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.list-item-inner {
  &__data-row {
    padding-bottom: $mds-space-2-x;
    padding-top: $mds-space-2-x;
    border-bottom: 1px solid #e5e5e5;
    font-size: $mds-space-2-x;

    &:hover {
      @include fc-hover-table-rows();
    }
  }
}
</style>
